import React, { useEffect } from 'react';

const ConfirmModal = ({
  open,
  // Back-compat aliases: several call sites were written against a different
  // prop contract than this component actually implements — accept both
  // rather than silently no-op (open undefined => modal never renders).
  isOpen,
  show,
  title = 'Confirm Action',
  message,
  confirmLabel,
  confirmText,
  cancelLabel,
  cancelText,
  confirmDanger = false,
  onConfirm,
  onCancel,
  onClose,
}) => {
  open = open ?? isOpen ?? show;
  confirmLabel = confirmLabel ?? confirmText ?? 'Confirm';
  cancelLabel = cancelLabel ?? cancelText ?? 'Cancel';
  onCancel = onCancel ?? onClose;
  useEffect(() => {
    if (!open) return;
    const handleKey = (e) => { if (e.key === 'Escape') onCancel?.(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="modal-backdrop" onClick={onCancel}>
      <div className="modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          <button className="modal-close" onClick={onCancel} aria-label="Close">&times;</button>
        </div>
        {message && <div className="modal-body">{message}</div>}
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel}>
            <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0}}><path d="M3 3l10 10M13 3L3 13"/></svg>
            {cancelLabel}
          </button>
          <button
            className={`btn ${confirmDanger ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
            autoFocus
          >
            {confirmDanger
              ? <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" style={{flexShrink:0}}><path d="M2 4h12M6 4V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1M5 4v9a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V4"/></svg>
              : <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" style={{flexShrink:0}}><path d="M2 8l5 5L14 3"/></svg>
            }
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
